/* eslint-disable sort-keys-fix/sort-keys-fix */
import { TinyColor } from "@ctrl/tinycolor";
import { Colors } from "../colors";
import emptyStateSvg from "../../public/images/EmptyState.svg";
export const defaultLightTheme2023 = (userTheme) => {
    const defaultText = Colors.gray[700];
    const warningText = Colors.auvikYellow[900];
    const errorText = Colors.auvikRed[800];
    const successText = Colors.auvikGreen[900];
    const infoText = Colors.auvikCyan[900];
    return {
        svg: {
            emptyStateSvg,
        },
        colors: {
            background: Colors.eggplantGray[50],
            mainText: defaultText,
            headerText: userTheme.themeBrandSecondary,
            linkColor: userTheme.themeAction,
            linkHoverColor: new TinyColor(userTheme.themeAction).lighten(10).toString(),
            secondardHeaderText: userTheme.themeBrandSecondary,
            auvik: Object.assign({}, Colors),
            // Accordion
            accordionColors: {
                accordionBackground: Colors.white,
                accordionBorder: Colors.lavenderGray[500],
                accordionHeader: Colors.lightGray[300],
                accordionTitle: defaultText,
                successIcon: Colors.auvikGreen[500],
                pendingIcon: Colors.auvikRed[500],
                blockedIcon: Colors.gray[500],
                defaultIcon: Colors.auvikEggplant[500],
            },
            // Alert Box
            alertBoxColors: {
                errorBackground: Colors.auvikRed[50],
                errorBorder: Colors.auvikRed[100],
                errorText,
                infoBackground: Colors.auvikSkyBlue[50],
                infoBorder: Colors.auvikLavender[100],
                infoText,
                successBackground: Colors.auvikGreen[50],
                successBorder: Colors.auvikGreen[100],
                successText,
                warningBackground: Colors.auvikYellow[50],
                warningBorder: Colors.auvikOrange[50],
                warningText,
            },
            // Card
            cardColors: {
                cardBackground: Colors.white,
                cardBorder: Colors.lavenderGray[500],
                cardIcon: userTheme.themeBrandSecondary,
            },
            // Chart
            chartColors: {
                axisLabels: defaultText,
                colors: [
                    Colors.auvikEggplant[500],
                    Colors.auvikLavender[500],
                    Colors.auvikYellow[500],
                    Colors.auvikGreen[500],
                    Colors.auvikOrange[500],
                    Colors.auvikPurple[500],
                    Colors.auvikLime[900],
                    Colors.auvikPink[900],
                    Colors.auvikSkyBlue[500],
                    Colors.auvikCyan[500],
                ],
                defaultBackgroundColor: Colors.white,
                defaultColor: Colors.auvikPurple[800],
                defaultReferenceArea: Colors.auvikPurple[50],
                emptyChartText: Colors.auvikEggplant[500],
                legendText: defaultText,
                risk: {
                    alert: Colors.auvikPurple[500],
                    critical: Colors.auvikRed[500],
                    high: Colors.auvikOrange[500],
                    medium: Colors.auvikYellow[500],
                    low: Colors.auvikGreen[500],
                    safe: Colors.auvikCyan[500],
                    default: Colors.auvikEggplant[500],
                },
                riskFill: {
                    critical: Colors.auvikRed[50],
                    high: Colors.auvikOrange[50],
                    medium: Colors.auvikYellow[50],
                    low: Colors.auvikGreen[50],
                    alert: Colors.auvikPurple[50],
                    safe: Colors.auvikCyan[50],
                    default: Colors.auvikEggplant[500],
                },
                riskStroke: {
                    critical: Colors.auvikRed[800],
                    high: Colors.auvikOrange[800],
                    medium: Colors.auvikYellow[800],
                    low: Colors.auvikGreen[800],
                    alert: Colors.auvikPurple[800],
                    safe: Colors.auvikCyan[800],
                    default: Colors.auvikEggplant[500],
                },
                stroke: Colors.lightGray[500],
                toolTipBackground: Colors.white,
                toolTipBorder: Colors.lavenderGray[300],
                toolTipDefaultColor: Colors.black,
                progressCircleBackground: Colors.gray[50],
            },
            // Checklist
            checklistColors: {
                currentItemCircleBorder: Colors.auvikPurple[500],
                currentItemCircleBackground: userTheme.themeBrandPrimary,
                futureItemCircleBorder: Colors.lavenderGray[500],
                doneItemCheckmark: userTheme.themeBrandPrimary,
                separatorBorder: Colors.lightGray[500],
            },
            // Dashboard
            dashboardColors: {
                keyValueValueText: defaultText,
                keyValueLabelText: Colors.auvikEggplant[500],
                multiKpiEmptyText: Colors.auvikEggplant[500],
                singleKpiValueText: Colors.auvikEggplant[500],
                singleKpiEmptyText: Colors.auvikEggplant[500],
            },
            // Deprecated Search Box
            deprecatedSearchBoxColors: {
                autocompleteHoverBackground: Colors.white,
                autocompleteHoverText: defaultText,
                autocompleteSelectedBackground: Colors.lightGray[200],
                autocompleteBackground: Colors.lightGray[200],
                autocompleteText: defaultText,
                listingTitleBackground: Colors.lightGray[200],
                listingBackground: Colors.white,
                wrapperBackground: Colors.white,
                wrapperBorder: Colors.lavenderGray[300],
            },
            // Drag and Drop:
            dndColors: {
                buttonColor: Colors.auvikPurple[500],
                hoverButtonBackgroundColor: Colors.auvikPurple[100],
                hoverCellBackgroundColor: Colors.auvikPurple[50],
            },
            // Expression Builder
            expressionBuilderColors: {
                background: Colors.white,
                ruleBackground: Colors.lightGray[300],
                connectingLines: Colors.auvikPurple[500],
            },
            // List
            listColors: {
                itemBackground: Colors.lightGray[50],
                itemText: defaultText,
                itemSelectedText: Colors.lightGray[300],
                itemSelectedBackground: userTheme.themeBrandPrimary,
                itemHoverBackground: `${userTheme.themeAction}26`,
                itemHoverText: defaultText,
                border: Colors.lavenderGray[400],
                background: Colors.white,
            },
            // Radio
            radioColors: {
                markBorder: Colors.lavenderGray[500],
                markBackground: Colors.white,
                markHoverBorder: userTheme.themeBrandPrimary,
                inputCheckedBackground: userTheme.themeBrandPrimary,
                disabledBackground: Colors.gray[50],
                disabledBorder: Colors.lavenderGray[500],
                backgroundAfter: Colors.white,
                disabledBackgroundAfter: Colors.gray[500],
                disabledLabel: Colors.lavenderGray[600],
            },
            // Inputs
            inputColors: {
                inputBackground: Colors.white,
                inputBorder: Colors.lavenderGray[500],
                inputText: defaultText,
                inputPlaceholder: Colors.gray[300],
                inputDisabledBackground: Colors.lightGray[300],
                inputDisabledText: Colors.gray[300],
                inputDisabledBorder: Colors.lavenderGray[500],
                fieldsetDisabledBackground: Colors.lightGray[200],
                inputFocusBorder: Colors.auvikSkyBlue[500],
                inputErrorBorder: Colors.auvikRed[800],
                inputErrorText: errorText,
                inputSuccessBorder: Colors.auvikGreen[500],
                inputFileInputDisabledBackground: Colors.white,
                prefixSuffixContainerBackground: Colors.lightGray[500],
                prefixSuffixContainerBorder: Colors.lavenderGray[500],
                prefixSuffixContainerDisabledText: Colors.gray[300],
                dropDownBackground: Colors.white,
                dropDownOptionFocusedBackground: userTheme.themeBrandPrimary,
                dropDownOptionBackground: Colors.white,
                dropDownOptionText: defaultText,
                dropDownOptionSelected: userTheme.themeBrandPrimary,
                dropDownOptionFocused: Colors.white,
                dropDownOptionError: errorText,
                dropDownOptionDisabled: Colors.lavenderGray[500],
                dropDownIndicatorHover: Colors.gray[500],
                dropDownIndicator: Colors.lavenderGray[500],
                noOptionsText: Colors.gray[700],
            },
            // Checkbox
            checkboxColors: {
                checkboxBackground: Colors.white,
                checkboxBorder: Colors.lavenderGray[500],
                checkboxCheckmark: userTheme.themeBrandPrimary,
                checkboxDisabledBackground: Colors.gray[50],
                checkboxDisabledBorder: Colors.lavenderGray[500],
                checkboxDisabledCheckmark: Colors.gray[500],
                checkboxFocusBorder: Colors.auvikSkyBlue[500],
            },
            // Flyout
            flyoutColors: {
                flyoutBackground: Colors.white,
                flyoutTitle: Colors.auvikEggplant[500],
                flyoutIcon: Colors.auvikEggplant[500],
                closeIcon: Colors.lavenderGray[800],
                collapsePanelButtonBackground: new TinyColor(`${userTheme.themeBrandPrimary}`).lighten(30).toString(),
                collapsePanelButtonBackgroundHover: new TinyColor(`${userTheme.themeBrandPrimary}`).lighten(25).toString(),
                collpasePanelButtonBorder: userTheme.themeBrandPrimary,
                collapsePanelArrowcolor: userTheme.themeBrandPrimary,
            },
            // Modals
            modalColors: {
                modalBackground: Colors.white,
                modalHeaderBackground: userTheme.themeBrandSecondary,
                modalHeaderText: Colors.white,
                modalFooter: Colors.lightGray[200],
                overlay: "rgba(0,0,0,0.7)",
            },
            // Details Area
            detailsAreaColors: {
                titleIconColor: Colors.gray[500],
                background: Colors.gray[50],
                shadowColor: Colors.gray[300],
            },
            // FormFieldWrapper
            formFieldWrapperColors: {
                helperText: Colors.gray[300],
                requiredStar: Colors.auvikRed[500],
            },
            // FormInputCopy
            formInputCopyColors: {
                icon: Colors.gray[500],
            },
            // FormInputPassword
            formInputPasswordColors: {
                buttonBorder: Colors.lavenderGray[500],
                buttonBackground: Colors.lightGray[500],
                buttonText: defaultText,
            },
            // FormPanel
            formPanelColors: {
                headerText: userTheme.themeBrandPrimary,
            },
            // Tabs
            tabsColors: {
                tabsBorders: Colors.lavenderGray[500],
                tabText: defaultText,
                tabHoverText: userTheme.themeBrandPrimary,
                selectedBackground: userTheme.themeBrandPrimary,
                tabBackgroundHover: Colors.lightGray[500],
                tabListBackground: Colors.lightGray[200],
            },
            // Step
            stepColors: {
                label: Colors.auvikEggplant[500],
                futureLabel: Colors.gray[300],
                completedBorder: Colors.auvikGreen[500],
                completed: Colors.auvikGreen[500],
                currentBorder: Colors.auvikPurple[500],
                current: Colors.auvikEggplant[500],
                future: Colors.gray[300],
                futureBorder: Colors.gray[300],
            },
            // Tooltip
            tooltipColors: {
                darkBackground: Colors.black,
                darkText: Colors.white,
                lightBackground: Colors.white,
                lightText: defaultText,
                tableBackground: Colors.white,
                tableText: defaultText,
            },
            // LoadingSpinner
            loadingSpinner: {
                color: userTheme.themeBrandPrimary,
            },
            // Popup
            popupColors: {
                background: Colors.white,
                border: Colors.lavenderGray[500],
            },
            // ProgressBar
            progressBarColors: {
                background: Colors.lavenderGray[400],
                containerBackground: Colors.auvikLavender[500],
                progress: userTheme.themeBrandPrimary,
                text: Colors.black,
            },
            // Toast
            toastColors: {
                red: {
                    background: Colors.auvikRed[50],
                    border: Colors.auvikRed[900],
                    text: errorText,
                },
                blue: {
                    background: Colors.auvikCyan[50],
                    border: Colors.auvikCyan[900],
                    text: Colors.auvikCyan[900],
                },
                green: {
                    background: Colors.auvikGreen[50],
                    border: Colors.auvikGreen[900],
                    text: successText,
                },
                yellow: {
                    background: Colors.auvikYellow[50],
                    border: Colors.auvikYellow[900],
                    text: Colors.auvikBrown[900],
                },
            },
            toggleColors: {
                checked: userTheme.themeBrandPrimary,
                disabled: Colors.lightGray[800],
                background: Colors.lavenderGray[600],
            },
            // Table
            tableColors: {
                columnPinningBoxShadowColor: Colors.auvikPurple[100],
                paginationActiveBackground: userTheme.themeBrandPrimary,
                paginationActiveText: Colors.white,
                paginationHoverBackground: `${userTheme.themeBrandPrimary}26`, // 15% opacity
                paginationHoverText: defaultText,
                paginationText: Colors.lavenderGray[500],
                placehoderGradient1: Colors.lavenderGray[300],
                placehoderGradient2: Colors.lightGray[50],
                statusMessageBackground: userTheme.themeBrandPrimary,
                statusMessageText: Colors.white,
                tableBackground: Colors.white,
                tableBorder: Colors.lightGray[200],
                tableRowEven: Colors.lightGray[200],
                tableRowHeader: Colors.lightGray[300],
                tableRowHeaderCaret: Colors.gray[300],
                tableRowHover: `${userTheme.themeAction}26`, // 15% opacity
                tableRowHoverSolid: Colors.auvikLavender[50],
                tableRowOdd: Colors.white,
                tableSortedIndicator: userTheme.themeBrandPrimary,
            },
            // Buttons
            invertedButtonColors: {
                invertedButtonBackground: Colors.white,
                invertedButtonText: userTheme.themeAction,
                invertedButtonBorder: userTheme.themeAction,
                invertedButtonHoverBackground: new TinyColor(userTheme.themeAction).darken(10).toString(),
                invertedButtonHoverText: Colors.white,
                invertedButtonHoverBorder: new TinyColor(userTheme.themeAction).darken(10).toString(),
                invertedButtonActiveBackground: userTheme.themeAction,
                invertedButtonActiveText: Colors.white,
                invertedButtonActiveBorder: userTheme.themeAction,
                invertedButtonDisabledBackground: Colors.white,
                invertedButtonDisabledText: Colors.lavenderGray[600],
                invertedButtonDisabledBorder: Colors.lavenderGray[600],
                invertedButtonFocusBackground: userTheme.themeAction,
                invertedButtonFocusText: Colors.white,
                invertedButtonFocusBorder: userTheme.themeAction,
            },
            invertedDarkButtonColors: {
                invertedDarkButtonBackground: Colors.white,
                invertedDarkButtonText: Colors.auvikEggplant[500],
                invertedDarkButtonBorder: Colors.auvikEggplant[500],
                invertedDarkButtonHoverBackground: Colors.auvikEggplant[500],
                invertedDarkButtonHoverText: Colors.white,
                invertedDarkButtonHoverBorder: Colors.auvikEggplant[500],
                invertedDarkButtonActiveBackground: Colors.auvikEggplant[500],
                invertedDarkButtonActiveText: Colors.white,
                invertedDarkButtonActiveBorder: Colors.auvikEggplant[500],
                invertedDarkButtonDisabledBackground: Colors.lavenderGray[600],
                invertedDarkButtonDisabledText: Colors.white,
                invertedDarkButtonDisabledBorder: Colors.lavenderGray[600],
                invertedDarkButtonFocusBackground: Colors.auvikEggplant[500],
                invertedDarkButtonFocusText: Colors.white,
                invertedDarkButtonFocusBorder: Colors.auvikEggplant[500],
            },
            secondaryButtonColors: {
                secondaryButtonDisabledBackground: Colors.lavenderGray[600],
                secondaryButtonFocusBackground: userTheme.themeAction,
                secondaryButtonHoverText: Colors.white,
                secondaryButtonFocusText: Colors.white,
                secondaryButtonText: userTheme.themeAction,
                secondaryButtonBackground: Colors.white,
                secondaryButtonHoverBackground: new TinyColor(userTheme.themeAction).darken(10).toString(),
                secondaryButtonDisabledText: Colors.white,
                secondaryButtonDisabledBorder: Colors.lavenderGray[600],
                secondaryButtonFocusBorder: userTheme.themeAction,
                secondaryButtonHoverBorder: new TinyColor(userTheme.themeAction).darken(10).toString(),
                secondaryButtonBorder: userTheme.themeAction,
            },
            tertiaryButtonColors: {
                tertiaryButtonHoverText: Colors.auvikLavender[900],
                tertiaryButtonFocusText: Colors.auvikLavender[800],
                tertiaryButtonText: Colors.auvikLavender[800],
                tertiaryButtonDisabledText: Colors.lavenderGray[600],
                tertiaryButtonDisabledBorder: Colors.white,
                tertiaryButtonFocusBorder: Colors.auvikLavender[900],
                tertiaryButtonHoverBorder: Colors.auvikLavender[800],
                tertiaryButtonBorder: Colors.white,
            },
            primaryButtonColors: {
                disabledBackground: Colors.lavenderGray[600],
                focusBackground: new TinyColor(userTheme.themeAction).darken(10).toString(),
                focusText: Colors.white,
                disabledText: Colors.white,
                hoverBackground: new TinyColor(userTheme.themeAction).darken(10).toString(),
                hoverText: Colors.white,
                background: userTheme.themeAction,
                text: Colors.white,
                default: Colors.lavenderGray[500],
            },
            destructiveButtonColors: {
                disabledBackground: Colors.lavenderGray[600],
                focusBackground: Colors.auvikRed[100],
                focusText: Colors.white,
                disabledText: Colors.black,
                hoverBackground: Colors.auvikRed[100],
                hoverText: Colors.white,
                background: Colors.auvikRed[800],
                text: Colors.white,
                default: Colors.lavenderGray[500],
            },
            iconButtonColors: {
                hoverBorder: userTheme.themeBrandPrimary,
                background: Colors.white,
                border: Colors.lavenderGray[500],
                disabled: Colors.lavenderGray[500],
                focusBackground: "rgba(0, 0, 0, 0.15)",
            },
            // icons
            iconColors: {
                avatar: Colors.auvikEggplant[500],
                avatarSecondary: Colors.auvikGreen[500],
                avatarTertiary: Colors.eggplantGray[50],
                avatarQuaternary: Colors.auvikPurple[800],
                button: Colors.auvikLavender[800],
                danger: Colors.auvikRed[500],
                disabled: Colors.eggplantGray[400],
                grey: Colors.lavenderGray[700],
                info: Colors.auvikCyan[800],
                infoDark: Colors.auvikSkyBlue[800],
                primary: Colors.auvikEggplant[500],
                secondary: Colors.auvikPurple[500],
                sidebar: Colors.white,
                success: Colors.auvikGreen[500],
                tertiary: Colors.auvikLavender[500],
                textColor: Colors.gray[700],
                tooltipQ: Colors.gray[500],
                warningDark: Colors.auvikOrange[500],
                warningLight: Colors.auvikYellow[500],
                white: Colors.white,
            },
            // Text
            textColors: {
                cardHeading: defaultText,
                cardHeadingCount: userTheme.themeBrandSecondary,
                critical: Colors.auvikOrange[800],
                default: defaultText,
                detailsArea: defaultText,
                emergency: errorText,
                greyIcon: Colors.gray[500],
                greyIconHover: userTheme.themeBrandPrimary,
                greyIconDisabled: Colors.lavenderGray[500],
                greyLink: defaultText,
                greyLinkHover: userTheme.themeBrandPrimary,
                header: Colors.auvikEggplant[500],
                informational: infoText,
                link: userTheme.themeBrandPrimary,
                subTitle: Colors.gray[300],
                warning: warningText,
                whiteIcon: Colors.lavenderGray[500],
                whiteIconHover: Colors.white,
                whiteIconDisabled: Colors.lavenderGray[500],
            },
            // SearchBox
            searchBoxColors: {
                buttonText: Colors.white,
                buttonBackground: Colors.lavenderGray[500],
                buttonActiveBackground: userTheme.themeBrandPrimary,
                buttonFocusBackground: Colors.lavenderGray[500],
                buttonHoverBackground: Colors.lavenderGray[500],
                magnifyingGlass: Colors.lavenderGray[500],
                dismiss: Colors.gray[300],
                dismissActive: Colors.white,
                filterBackground: `${userTheme.themeBrandPrimary}29`, // 16% opacity
                filterActiveBackground: userTheme.themeBrandPrimary,
                filterBorder: userTheme.themeBrandPrimary,
                filterText: Colors.gray[700],
                filterActiveText: Colors.white,
                filterDisabledBackground: Colors.lavenderGray[50],
                filterDisabledBorder: Colors.lavenderGray[100],
                filterDisabledText: defaultText,
                dropDownBorder: Colors.lavenderGray[500],
                dropDownBackground: Colors.white,
                hintBackground: Colors.white,
                hintText: defaultText,
                facetPillBackground: `${userTheme.themeBrandPrimary}29`, // 16% opacity
                facetPillBorder: userTheme.themeBrandPrimary,
                facetPillText: defaultText,
                dropdownSuggestionTitle: defaultText,
                suggestionItemText: Colors.gray[500],
                suggestionItemActiveText: Colors.white,
                suggestionItemActiveBackground: userTheme.themeBrandPrimary,
                dropdownTitleBackground: Colors.lightGray[200],
                dropdownTitleText: Colors.gray[300],
                arrow: Colors.lightGray[200],
                arrowBorder: Colors.white,
                arrowContainerBorder: Colors.lavenderGray[500],
            },
            // Wizard
            wizardColors: {
                border: Colors.lavenderGray[500],
                stepLabelCurrent: Colors.auvikEggplant[500],
                stepLabelStyle: defaultText,
                currentStepBorder: Colors.auvikPurple[500],
                currentCircleBorder: userTheme.themeBrandPrimary,
                separatorLine: userTheme.themeBrandPrimary,
                separatorLineCompleted: userTheme.themeBrandPrimary,
                separatorLineCurrent: Colors.lavenderGray[500],
                separatorLinePending: Colors.lavenderGray[500],
                completedBackground: userTheme.themeBrandPrimary,
                currentBackground: Colors.white,
                pendingBackground: Colors.lavenderGray[500],
                footerBackground: Colors.lightGray[200],
            },
            // Badge
            badgeColors: {
                alertBackground: Colors.auvikRed[800],
                alertText: Colors.white,
                badgeLabelText: defaultText,
                chipBackground: new TinyColor(userTheme.themeBrandPrimary).lighten(45).toString(),
                closeButton: Colors.gray[300],
                chipBorder: userTheme.themeBrandPrimary,
                chipText: defaultText,
                criticalBackground: Colors.auvikOrange[800],
                criticalText: Colors.white,
                criticalLightBackground: Colors.auvikOrange[50],
                criticalLightBorder: Colors.auvikOrange[900],
                criticalLightText: Colors.auvikOrange[900],
                customBackground: Colors.auvikEggplant[500],
                customText: Colors.white,
                customLightBackground: Colors.eggplantGray[50],
                customLightBorder: Colors.auvikEggplant[500],
                customLightText: Colors.auvikEggplant[500],
                debugBackground: Colors.gray[500],
                debugText: Colors.white,
                defaultBackground: Colors.auvikLavender[500],
                defaultText: Colors.white,
                dryBackground: Colors.auvikPurple[50],
                dryText: defaultText,
                emergencyBackground: Colors.auvikRed[500],
                emergencyText: Colors.white,
                emergencyLightBackground: Colors.auvikRed[50],
                emergencyLightText: Colors.auvikRed[900],
                emergencyLightBorder: Colors.auvikRed[900],
                errorBackground: Colors.auvikRed[800],
                errorText: Colors.white,
                informationalBackground: Colors.auvikCyan[900],
                informationalText: Colors.white,
                informationalLightBackground: Colors.auvikCyan[50],
                informationalLightBorder: Colors.auvikCyan[800],
                informationalLightText: Colors.auvikCyan[800],
                noticeBackground: Colors.auvikCyan[900],
                noticeText: Colors.white,
                primaryBackground: userTheme.themeAction,
                primaryText: Colors.white,
                primaryDarkBackground: new TinyColor(userTheme.themeAction).darken(12.5).toString(),
                primaryDarkText: Colors.white,
                primaryLightBackground: Colors.auvikLavender[50],
                primaryLightText: Colors.auvikLavender[900],
                primaryLightBorder: Colors.auvikLavender[900],
                secondaryBackground: Colors.auvikPink[800],
                secondaryText: Colors.white,
                secondaryLightBackground: Colors.auvikPink[50],
                secondaryLightBorder: Colors.auvikPink[500],
                secondaryLightText: Colors.auvikPink[500],
                successBackground: Colors.auvikGreen[900],
                successText: Colors.white,
                successLightBackground: Colors.auvikGreen[50],
                successLightBorder: Colors.auvikGreen[900],
                successLightText: Colors.auvikGreen[900],
                warningBackground: Colors.auvikYellow[500],
                warningText: defaultText,
                warningLightBackground: Colors.auvikYellow[50],
                warningLightBorder: Colors.auvikYellow[900],
                warningLightText: Colors.auvikYellow[900],
            },
        },
    };
};
